/**
 * Метаданные анкеты. Здесь нет ни одной строки текста для человека —
 * тексты живут в src/content/{ru,kk}.ts и связаны с этими id.
 *
 * Порядок массива QUESTIONS определяет порядок ответов в Assessment.answers,
 * поэтому менять его без поднятия ASSESSMENT_VERSION нельзя.
 */
/**
 * Версия 2: убран вопрос про контакт — для связи хватает почты из аккаунта,
 * а лишний раз просить телефон у человека, который ещё ничего не решил, незачем.
 */
export const ASSESSMENT_VERSION = 2;
export const AXIS_IDS = [
    'mind',
    'ready',
    'mission',
    'role',
    'home',
    'kin',
    'resp',
    'accept',
];
/** 12 условий: принципиально / важно / желательно — они же «12 сфер» на лендинге. */
export const COND_IDS = [
    'faith',
    'language',
    'origin',
    'age',
    'education',
    'past',
    'looks',
    'wealth',
    'separateHome',
    'children',
    'wifeCareer',
    'geography',
];
export const FORK_IDS = ['live', 'money', 'whoDecides', 'wedding', 'conflict', 'cooled'];
export const SELF_IDS = ['age', 'city', 'faith', 'lang', 'edu', 'past', 'field'];
export const WANT_IDS = ['faith', 'lang', 'age', 'edu', 'past', 'geo'];
/** Уровни шкал берутся из книги, стр. 86–88. */
export const FAITH_LEVELS = 6;
export const LANG_LEVELS = 6;
export const EDU_OPTIONS = 3;
export const PAST_OPTIONS = 4;
export const FIELD_OPTIONS = 11;
export const LEVEL_OPTIONS = 3; // принципиально / важно / желательно
export const LIKERT_OPTIONS = 5;
/** По пять утверждений на ось; true — обратный пункт. */
const LIKERT_SPEC = {
    mind: [false, true, false, true, false],
    ready: [false, false, true, false, false],
    mission: [false, false, true, false, true],
    role: [false, true, true, false, true],
    home: [false, true, false, true, false],
    kin: [false, true, false, false, true],
    resp: [true, false, true, false, true],
    accept: [true, false, true, false, true],
};
const likert = AXIS_IDS.flatMap((axis) => LIKERT_SPEC[axis].map((reverse, i) => ({
    id: `lik.${axis}.${i + 1}`,
    kind: 'likert',
    part: 1,
    axis,
    reverse,
})));
const conds = COND_IDS.map((cond) => ({
    id: `cond.${cond}`,
    kind: 'cond',
    part: 2,
    cond,
}));
const FORK_WEIGHT = {
    live: 'high',
    money: 'high',
    whoDecides: 'high',
    wedding: 'normal',
    conflict: 'normal',
    cooled: 'normal',
};
const forks = FORK_IDS.map((fork) => ({
    id: `fork.${fork}`,
    kind: 'fork',
    part: 3,
    fork,
    options: 3,
    weight: FORK_WEIGHT[fork],
}));
const selves = [
    { id: 'self.age', kind: 'number', part: 4, min: 16, max: 70 },
    { id: 'self.city', kind: 'text', part: 4, maxLength: 40, optional: false },
    { id: 'self.faith', kind: 'pick', part: 4, options: FAITH_LEVELS },
    { id: 'self.lang', kind: 'pick', part: 4, options: LANG_LEVELS },
    { id: 'self.edu', kind: 'pick', part: 4, options: EDU_OPTIONS },
    { id: 'self.past', kind: 'pick', part: 4, options: PAST_OPTIONS },
    { id: 'self.field', kind: 'pick', part: 4, options: FIELD_OPTIONS },
];
/** Последний вариант в каждом требовании — «не важно». */
const wants = [
    { id: 'want.faith', kind: 'pick', part: 5, options: FAITH_LEVELS + 1 },
    { id: 'want.lang', kind: 'pick', part: 5, options: LANG_LEVELS + 1 },
    { id: 'want.age', kind: 'pick', part: 5, options: 4 },
    { id: 'want.edu', kind: 'pick', part: 5, options: 3 },
    { id: 'want.past', kind: 'pick', part: 5, options: 4 },
    { id: 'want.geo', kind: 'pick', part: 5, options: 4 },
];
export const QUESTIONS = [...likert, ...conds, ...forks, ...selves, ...wants];
export const N_LIKERT = likert.length; // 40
export const N_COND = conds.length; // 12
export const N_FORK = forks.length; // 6
export const N_SELF = selves.length; // 7
export const N_WANT = wants.length; // 6
export const OFFSET_COND = N_LIKERT;
export const OFFSET_FORK = OFFSET_COND + N_COND;
export const OFFSET_SELF = OFFSET_FORK + N_FORK;
export const OFFSET_WANT = OFFSET_SELF + N_SELF;
export const TOTAL_QUESTIONS = QUESTIONS.length; // 71
/** Значение «не важно» в требованиях уровня (последний вариант). */
export const WANT_ANY_FAITH = FAITH_LEVELS + 1;
export const WANT_ANY_LANG = LANG_LEVELS + 1;
export const WANT_ANY_AGE = 4;
export const WANT_ANY_EDU = 3;
export const WANT_ANY_PAST = 4;
export const WANT_ANY_GEO = 4;
/** Уровень важности условия. */
export const LEVEL_CRITICAL = 1;
export const LEVEL_IMPORTANT = 2;
export const LEVEL_NICE = 3;
export function questionAt(index) {
    const q = QUESTIONS[index];
    if (!q)
        throw new RangeError(`Нет вопроса с индексом ${index}`);
    return q;
}
export function indexOfQuestion(id) {
    const i = QUESTIONS.findIndex((q) => q.id === id);
    if (i < 0)
        throw new RangeError(`Неизвестный вопрос: ${id}`);
    return i;
}
//# sourceMappingURL=questions.js.map